/**
 * 模板相关接口
 */

import { fetchApi } from "../interceptor"
const V2 = "v2"

/**
 * 设为我的模板
 * @param {*} data
 * websitedId=网站id
 * name=模板名称
 * typeId=模板类型id
 */
export const setMyTemplate = data => {
  const url = `${V2}/website/${data.websiteId}/template`
  return fetchApi(url, data.param, "POST", "params")
}

/**
 * 获取模板类型
 */
export const queryTemplateType = () => {
  const url = `${V2}/template/types`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 模板类型下的模板列表
 * t 必须【组件ID，/v2/template/types查询回来的列表里的encId属性】
 */
export const queryTemplateList = data => {
  const url = `${V2}/template/list?t=${data.t}`
  return fetchApi(url, null, "POST", "params")
}

/**
 * 根据templateId查pageList
 */
export const queryPageListByTemplateId = data => {
  const url = `${V2}/template/${data.templateId}/page/list`
  return fetchApi(url, null, "GET", "params")
}
